var map = {
	"./Vector rotated.svg": "2829",
	"./Vector-bottom rotated.svg": "e239",
	"./Vector-bottom.svg": "9443",
	"./Vector.svg": "e455",
	"./arrow-green.svg": "4a62",
	"./arrow-grey.svg": "5ace",
	"./arrow-red.svg": "ae5c",
	"./arrow-simple-forward.svg": "51b2",
	"./arrow.svg": "21e2",
	"./calendar-lesson.svg": "9e17",
	"./calendar-pin.svg": "436d",
	"./chat-write.svg": "1f34",
	"./chevron-left.svg": "d0fe",
	"./chevron-right.svg": "88ee",
	"./clock.svg": "755b",
	"./close-black.svg": "c9cf",
	"./close-green.svg": "99f49",
	"./close-homework.svg": "14aa",
	"./close.svg": "8b1b",
	"./cross-circle.svg": "e798",
	"./download-homework.svg": "e316",
	"./download-logopedist-files.svg": "2e88",
	"./edit.svg": "daf0",
	"./eye.svg": "7364",
	"./file-wrapper.svg": "8379",
	"./format-pdf.svg": "ac35",
	"./gear.svg": "f571",
	"./green-rounded-cross.svg": "a289",
	"./group.svg": "51a3",
	"./heart-black.svg": "01e0",
	"./heart.svg": "7d16",
	"./hide.svg": "a010",
	"./homework-lesson-black.svg": "af3a",
	"./homework-lesson.svg": "4cac",
	"./info-notice.svg": "da04",
	"./loader.svg": "04ff",
	"./not-verified.svg": "c47c",
	"./phone-call.svg": "c251",
	"./pin.svg": "862b",
	"./save.svg": "9344",
	"./select-arrow.svg": "3dbd",
	"./star-filled.svg": "3d1d",
	"./star.svg": "cc90",
	"./tick-circle.svg": "c821",
	"./time-lesson.svg": "5599",
	"./trash.svg": "af22",
	"./user.svg": "6aed",
	"./verified.svg": "256c",
	"./warning-notice.svg": "5212"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";